import QuestionCard from "elements/QuestionCard";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";

const CoOp = () => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<QuestionCard
				id="co-op"
				value={specialFieldsValue?.is_co_op_where_some_taxes_are_paid_jointly}
				setValue={(v: boolean | undefined) =>
					setSpecialFieldsValue({
						is_co_op_where_some_taxes_are_paid_jointly: v,
					})
				}
				tooltipText=""
				question="Is this a co-op where some taxes are paid jointly?"></QuestionCard>
			<ButtonV2
				size="large"
				disabled={
					specialFieldsValue?.is_co_op_where_some_taxes_are_paid_jointly ===
					undefined
				}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default CoOp;
